export default __webpack_public_path__ + "static/restroom_b.11bc4c2ad23ba5afecbdea237b619b7e.png";